<template>
  <div class="csm">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'数据统计'},{name:'CSM'}]"></breadcrumb>
    <div class="csm-wrap">
      <div class="csm-contain">
        <data-top-nav></data-top-nav>
        <div class="csm-search_wrap">
          <el-select v-model="channel" @change="channelChange" placeholder="请选择">
            <el-option
              v-for="item in this.channelList"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select v-model="limit" @change="limitChange" placeholder="请选择">
            <el-option
              v-for="item in this.limiList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select v-model="weidu" @change="weiduChange" placeholder="请选择">
            <el-option
              v-for="item in this.weiduList"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-if="limit===43 || limit === 44"
            v-model="yearProgress"
            @change="yearProgressChange"
            placeholder="请选择"
          >
            <el-option value="展示进度"></el-option>
            <el-option value="展示详情"></el-option>
          </el-select>
          <div v-if="((limit===43||limit===44) && yearProgress==='展示详情')" class="cms-select_month">
            <el-date-picker @change="monthChange" v-model="month" type="month" placeholder="选择年月"></el-date-picker>
          </div>
          <div v-else class="csm-button_wrap">
            <el-date-picker @change="yearChange" v-model="year" type="year" placeholder="选择年"></el-date-picker>
          </div>
        </div>
        <div class="csm-contant_wrap">
          <div v-if="limit!==39" class="csm-table-wrap">
            <div class="csm-table_title">
              <span v-if="year">{{tableTitle}}</span>
              <div class="csm-table_title_right">
                 <a  @click=" $refs['file'].click()" v-if="limit===41||limit===40" class="csm-table_download">
                       <input class="csm-table-file_input"
                     type="file"
                     style="display:none"
                     @change="importExcel"
                     ref="file">
                  <font-awesome-icon

                    style="color:#F0722B;margin-right:5px"
                    :icon="['fas', 'level-down-alt']"
                  />导入Excel
                </a>
                <a class="csm-table_download" @click="exportExcel()">
                  <font-awesome-icon
                    style="color:#39B54A;margin-right:5px"
                    :icon="['fas', 'level-up-alt']"
                  />导出Excel
                </a>
                <div class="csm-table_bar" @click="showChart" v-if="limit===40">
                  <font-awesome-icon :icon="['fas', 'chart-bar']"/>
                </div>
              </div>
            </div>
            <div class="csm-table">
              <table v-if="limit === 40">
                <tr>
                  <th>序号</th>
                  <th>{{weiduName}}</th>
                  <th>推及人口(千)</th>
                  <th>基数(%)</th>
                  <th>任务目标(%)</th>
                </tr>
                <tr v-for="(item,index) in list" :key="item.id">
                  <td>{{index +1}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.population}}</td>
                  <td>{{item.baseNoPerc}}</td>
                  <td>{{item.taskNoPerc}}</td>
                </tr>
              </table>
              <table v-else-if="limit===43 && yearProgress==='展示详情'">
                <tr>
                  <th>序号</th>
                  <th>{{weiduName}}</th>
                  <th>城市</th>
                  <th>年目标</th>
                  <th>
                    <span v-if="month">{{month.getMonth()+1}}</span>月加权数据
                  </th>
                  <th>完成比例</th>
                  <th>采用比例</th>
                  <th>任务比例</th>
                </tr>
                <tr v-for="(item,index) in list" :key="index">
                  <td>{{index+1}}</td>
                  <td>
                    <span>{{item.name}}</span>
                  </td>
                  <td>{{item.cityName}}</td>
                  <td>{{item.taskNoPerc}}%</td>
                  <td>{{item.mn}}%</td>
                  <td>{{item.mnFinished}}%</td>
                  <td>{{item.mnUsed}}%</td>
                  <td>{{item.avgUsed}}%</td>
                </tr>
              </table>
              <table v-else-if="limit===44 && yearProgress==='展示详情'">
                <tr>
                  <th>序号</th>
                  <th>{{weiduName}}</th>
                  <th>城市</th>
                  <th>年目标</th>
                  <th>本月数值</th>
                  <th>实际比例</th>
                  <th>采用比例</th>
                  <th>任务比例</th>
                </tr>
                <tr v-for="(item,index) in list" :key="index">
                  <td>{{index+1}}</td>
                  <td>
                    <span>{{item.name}}</span>
                  </td>
                  <td>{{item.cityName}}</td>
                  <td>{{item.taskNoPerc}}%</td>
                  <td>{{item.mn}}%</td>
                  <td>{{item.mnFinished}}%</td>
                  <td>{{item.mnUsed}}%</td>
                  <td>{{item.avgUsed}}%</td>
                </tr>
              </table>
              <table v-else>
                <tr>
                  <th>序号</th>
                  <th>{{weiduName}}</th>
                  <th v-for="m of 12" :key="m">
                    <a @click="showMonthChart(m)">{{m}}月</a>
                  </th>
                </tr>
                <tr v-for="(item,index) in list" :key="item.id">
                  <td>{{index +1}}</td>
                  <td>
                    <a @click="showCityChart(index)">{{item.name}}</a>
                  </td>
                  <td style="width:80px" v-for="m of 12" :key="m">{{item[`m${m}`]}}%</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="csm-chart"
      :title="chartTitle"
      :visible.sync="optionVisible"
      :width="width+20+'px'"
    >
      <v-chart theme="dark"
        v-if="optionVisible"
        :style="{width:width+'px'}"
        :options="option"
        style="height:500px"
      ></v-chart>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/servies/axios";
import api from "@/servies/api";
import breadcrumb from "@/components/breadcrumb";
import dataTopNav from "@/components/dataTopNav";
import ECharts from "vue-echarts";
import "echarts";
import moment from "moment";
import _ from 'lodash'
export default {
  components: {
    breadcrumb,
    dataTopNav,
    "v-chart": ECharts
  },
  data() {
    return {
      width: "",
      channel: "",
      channelName: "",
      limit: "",
      limitName: "",
      weidu: "",
      weiduName: "",
      year: "",
      month: "",
      yearProgress: "展示详情",

      limiList: [],
      channelList: [],
      weiduList: [],

      list: [],
      tableTitle: "",

      optionVisible: false,
      chartTitle: ""
    };
  },
   computed: {
    xlist() {
      let list = _.cloneDeep(this.list)
      if (
          list[list.length - 1].name === '总计')
      {
        list.pop()
      }
      return list
    }
  },
  created() {
    Promise.all([
      this.getLimitList(),
      this.getWeiduList(),
      this.getChannelList()
    ])
      .then(() => {
        this.limitChange()
      })
      .catch(error => {
        console.log(error);
        this.$message.error("网络错误，稍后重试");
      });
  },
  //获取户数列表下的权限
  methods: {
    //初始化
    initDate() {
      this.year = new Date();
      this.month = new Date();
    },
    allList() {
      switch (this.limit) {
        case 40:
          this.limitName = "任务分配";
          this.getCsmYearTask();
          break;
        case 41:
          this.limitName = "原始数据";
          this.getCsmOriginal();
          break;
        case 42:
          this.limitName = "加权数据";
          this.getCsmWeighted();
          break;
        case 43:
          this.yearProgress = "展示进度";
          this.limitName = "全年进度";
          this.getYearProgressList();
          break;
        case 44:
          this.yearProgress = "展示进度";
          this.limitName = "当月任务";
          this.getMonthProgressList();
          break;
      }
    },
    getLimitList() {
      for (let item1 of this.$store.state.menuList) {
        if (item1.id === 50) {
          let list = item1.children;
          for (let item2 of list) {
            if (item2.id === 9) {
              this.limiList = item2.children;
              this.limit = this.limiList[0].id;
              this.limitName = this.limiList[0].name;
            }
          }
        }
      }
    },
    getChannelList() {
      return axios.get(api.getChannelTypeList).then(res => {
        if (res.data.code === 0) {
          console.log("获取台类型成功", res.data.result);
          this.channelList = res.data.result;
          this.channel = this.channelList[0].code;
          this.channelName = this.channelList[0].desc;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getWeiduList() {
     return axios.get(api.getCsmWeiduList).then(res => {
        if (res.data.code === 0) {
          console.log("获取维度类型成功", res.data.result);
          this.weiduList = res.data.result;
          this.weidu = this.weiduList[1].code;
          this.weiduName = this.weiduList[1].desc;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //频道改变
    channelChange(channelCode) {
      switch (channelCode) {
        case 0:
          this.channelName = "中文台";
          break;
        case 1:
          this.channelName = "资讯台";
          break;
      }
      this.limitChange();
    },
    limitChange() {
      this.initDate();
      this.allList();
    },
    //维度改变
    weiduChange() {
      switch (this.weidu) {
        case 4:
          this.weiduName = "城市";
          break;
        case 3:
          this.weiduName = "个人";
          break;
        case 2:
          this.weiduName = "省份";
          break;
        case 1:
          this.weiduName = "代表处";
          break;
      }
      this.allList();
    },
    //年选择框改变
    yearChange(v) {
      this.allList();
    },
    //月选择框改变
    monthChange(v) {
      if (this.limit === 43) {
        this.getYearMonthProgressList();
      } else {
        this.getCsmMonthProcessMonth();
      }
    },
    //全年进度查看详情或者进度select改变
    yearProgressChange(v) {
      this.initDate();
      if (v === "展示详情") {
        if (this.limit === 43) {
          this.getYearMonthProgressList();
        } else {
          this.getCsmMonthProcessMonth();
        }
      } else {
        if (this.limit === 43) {
          this.getYearProgressList();
        } else {
          this.getMonthProgressList();
        }
      }
    },
    //获取任务分配列表
    getCsmYearTask() {
      this.tableTitle =
        this.year.getFullYear() +
        "年CSM年度任务分配 --【" +
        this.channelName +
        "】-【" +
        this.weiduName +
        "】";
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.year.getFullYear()
      };
      axios
        .post(api.getCsmYearTask, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取任务分配列表成功", res.data.result);
            this.list = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    //获取原始数据
    getCsmOriginal() {
      this.tableTitle =
        this.year.getFullYear() +
        "年CSM年度原始数据 --【" +
        this.channelName +
        "】-【" +
        this.weiduName +
        "】";
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.year.getFullYear()
      };
      axios
        .post(api.getCsmOriginal, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取原始数据列表成功", res.data.result);
            this.list = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    //显示城市一年的原始数据分配图
    showCityChart(index) {
      this.width = 700;
      let city = this.list[index];
      let weidu;
      if (this.weidu === 2) {
        weidu = city.areaName;
      } else if (this.weidu === 3) {
        weidu = city.userName;
      } else {
        weidu = city.representOfficeName;
      }
      this.chartTitle =
      this.year.getFullYear() +
        '年' +
        this.limitName +
        '图 --【'+this.channelName+'】-【'+this.weiduName + '】'
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 20
        },
        tooltip: {},
        dataset: {
          source: city
        },
        xAxis: {
          type: "category",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ]
        },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            type: "line",
            data: [
              city.m1,
              city.m2,
              city.m3,
              city.m4,
              city.m5,
              city.m6,
              city.m7,
              city.m8,
              city.m9,
              city.m10,
              city.m11,
              city.m12
            ]
          }
        ]
      };
      this.optionVisible = true;
    },
    //显示所有城市某月的原始数据对比图
    showMonthChart(month) {
      this.width = this.list.length * 20 < 500 ? 500 : this.list.length * 20;
      this.chartTitle =
     this.year.getFullYear() +
        '年' +
        month +
        '月' +
        this.limitName +
        '对比图 --【'+this.channelName+'】-【'+this.weiduName+'】'
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 120
        },
        tooltip: {},
        xAxis: {
          type: "category",
          data: this.xlist.map(item=>{
            return item.name
          }),
          axisLabel: {
            interval: 0,
            formatter: function(value) {
              return value.split("").join("\n");
            },
            textStyle: {
              fontSize: 10 //更改坐标轴文字大小
            }
          }
        },
        yAxis:
          this.limit === 36
            ? [
                {
                  name: "百分比(%)"
                }
              ]
            : {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            type: "bar",
            data: this.xlist.map(item => {
              return item["m" + month];
            })
          }
        ]
      };
      this.optionVisible = true;
    },
    //获取加权数据列表
    getCsmWeighted() {
      this.tableTitle =
        this.year.getFullYear() +
        "年CSM年度加权数据 --【" +
        this.channelName +
        "】-【" +
        this.weiduName +
        "】";
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.year.getFullYear()
      };
      axios
        .post(api.getCsmWeighted, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取加权数据列表成功", res.data.result);
            this.list = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    //全年进度列表
    getYearProgressList() {
      this.tableTitle =
        this.year.getFullYear() +
        "年任务进度--【" +
        this.channelName +
        "】-【" +
        this.weiduName +
        "】";

      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.year.getFullYear()
      };
      axios
        .post(api.getCsmYearProcess, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("全年进度列表成功", res.data.result);
            this.list = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    //全年进度某月详情列表
    getYearMonthProgressList() {
      this.tableTitle =
        this.month.getFullYear() +
        "年" +
        (this.month.getMonth() + 1) +
        "月 CSM 年任务进度详情--【" +
        this.channelName +
        "】-【" +
        this.weiduName +
        "】";
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.month.getFullYear(),
        month: this.month.getMonth() + 1
      };
      axios
        .post(api.getCsmYearProcessMonth, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("全年任务进度详情成功", res.data.result);
            this.list = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    //当月任务列表
    getMonthProgressList() {
      this.tableTitle =
        this.year.getFullYear() +
        "年本月任务完成情况--【" +
        this.channelName +
        "】-【" +
        this.weiduName +
        "】";
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.year.getFullYear()
      };
      axios
        .post(api.getCsmMonthProcess, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("当月任务列表成功", res.data.result);
            this.list = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    getCsmMonthProcessMonth() {
      this.tableTitle =
        this.month.getFullYear() +
        "年" +
        (this.month.getMonth() + 1) +
        "月 CSM 月任务进度详情--【" +
        this.channelName +
        "】-【" +
        this.weiduName +
        "】";
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.month.getFullYear(),
        month: this.month.getMonth() + 1
      };
      axios
        .post(api.getCsmMonthProcessMonth, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("月任务进度详情成功", res.data.result);
            this.list = res.data.result;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    //导出excel
    exportExcel() {
      let params = {};
      let url = "";
      switch (this.limit) {
        case 40:
          params = {
            channel: this.channel,
            weidu: this.weidu,
            year: this.year.getFullYear()
          };
          url = api.getCsmYearTaskExcel;
          break;
        case 41:
          params = {
            channel: this.channel,
            weidu: this.weidu,
            year: this.year.getFullYear()
          };
          url = api.getCsmOriginalExcel;
          break;
        case 42:
          params = {
            channel: this.channel,
            weidu: this.weidu,
            year: this.year.getFullYear()
          };
          url = api.getCsmWeightedExcel;
          break;
        case 43:
        if(this.yearProgress==='展示进度'){
          params = {
            channel: this.channel,
            weidu: this.weidu,
            year: this.year.getFullYear()
          };
          url = api.getCsmYearProcessExcel;}
          else {
            params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.month.getFullYear(),
        month: this.month.getMonth() + 1
      };
      url= api.getCsmYearProcessMonthExcel
          }
          break;
        case 44:
          if(this.yearProgress==='展示进度'){
          params = {
            channel: this.channel,
            weidu: this.weidu,
            year: this.year.getFullYear()
          };
          url = api.getCsmMonthProcessExcel;}
          else {
            params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.month.getFullYear(),
        month: this.month.getMonth() + 1
      };
      url= api.getCsmMonthProcessMonthExcel
          }
          break;
      }
      axios({
        // 用axios发送post请求
        method: "post",
        url: url,
        data: params,
        responseType: "blob" // 表明返回服务器返回的数据类型
      })
        .then(res => {
          let blob = new Blob([res.data], { type: "application/x-xls" });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${this.tableTitle}.xls`;
          link.click();
          window.URL.revokeObjectURL(link.href);
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    //导入数据
    importExcel(e){
      let file = e.target.files[0]
      if (file.length) {
        return
      }
        let param = new FormData()
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      let url =''
      if(this.limit === 41){
         param.append('file', file)
        url = api.importCSMOriginal
      } else {
        param.append('file', file)
        url = api.importCSMYearTask
      }
      axios
        .post(url, param, config)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '上传文件成功',
              type: 'success'
            })
            this.allList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })

    },
    showChart() {
      this.width = this.list.length * 20 < 500 ? 500 : this.list.length * 20;
      this.chartTitle =
        this.year.getFullYear() +
        "年" +
        this.limitName +
        "各城市对比--【" +
        this.channelName +
        "】-【" +
        this.weiduName +
        "】";
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 120
        },
        tooltip: {},
        dataset: {
          source: this.list
        },
        xAxis: {
          type: "category",
          data: this.list.map(item => {
            return item.name;
          }),
          axisLabel: {
            interval: 0,
            formatter: function(value) {
              return value.split("").join("\n");
            },
            textStyle: {
              fontSize: 10 //更改坐标轴文字大小
            }
          }
        },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            name: "基数",
            type: "bar",
            data: this.list.map(item => {
              return item.baseNoPerc;
            })
          },
          {
            name: "任务目标",
            type: "bar",
            data: this.list.map(item => {
              return item.taskNoPerc;
            })
          }
        ]
      };
      this.optionVisible = true;
    }
  }
};
</script>

<style lang="scss">
.csm {
  .csm-wrap {
    padding: 77px 30px 0px 30px;
    .csm-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .csm-search_wrap {
        display: flex;
        background: #f8f8f8;
        padding: 20px 27px 5px 27px;
        justify-content: flex-start;
        flex-wrap: wrap;
        .el-select {
          width: 108px;
          margin-right: 17px;
          margin-bottom: 15px;
        }
        .el-range-editor {
          margin-right: 17px;
        }
        .csm-button_wrap {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .el-date-editor {
            width: 108px;
            height: 40px;
          }
        }
        .cms-select_month {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .el-date-editor {
            width: 120px;
            height: 40px;
          }
        }
        .csm-select_month {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .el-date-editor {
            width: 120px;
          }
        }
      }
      .csm-contant_wrap {
        padding: 30px;
        .csm-table_title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 27px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .csm-table_title_right {
            display: flex;
            .csm-table_bar {
              background: #fff;
              height: 40px;
              width: 50px;
              cursor: pointer;
              line-height: 40px;
              text-align: center;
              border-radius: 4px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
                margin-left: 10px;
            }
            .csm-table_download {
                margin-left: 10px;
              cursor: pointer;
              text-decoration: none;
              width: 108px;
              height: 40px;
              border-radius: 4px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
              font-size: 14px;
              font-weight: 500;
              line-height: 40px;
              text-align: center;
            }
          }
        }
        .csm-table {
          min-height: 470px;
          tr {
            height: 47px;
            th {
              position: sticky;
              top:113px;
              height: 40px;
              background: #5d5d5d;
              color: #fff;
              a {
                cursor: pointer;
              }
            }
            td {
              text-align: center;
              height: 54px;
              a {
                cursor: pointer;
                color: #f0722b;
              }
              div {
                display: inline-block;
              }
            }
          }
        }
        .csm-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .csm-chart {
    .el-dialog__body {
      padding-top: 0px;
      padding-bottom: 10px;
      padding-left: 10px;
    }
  }
}
</style>
